// 외주 의뢰서 — 전용 페이지(/outsource-request).
// 10-30 대표 "cad디자인 외주 없애주고, 재택 디자이너도 없애줘": CAD 디자인 외주 화면(CadOutsourcePage·CadDesignHome·의뢰 종류 고르기)을 걷어냈다.
//   이제 이 페이지 = 외주 의뢰서 허브(새 의뢰 = PC 케이스 / 파일로 보내기 · 보낸 의뢰 · 받은 의뢰 · 연결 요청 · 월별 요약).
//   옛 CAD 의뢰 기록(designOutsourceRequests)·서버 함수는 지우지 않았다(보관·법정 보존). 옛 화면 원본: ~/.Trash/CAD재택_20261030/
import React, { useEffect, useState } from 'react';
import { getFeatures, isOutsourceMfOn } from '../utils/features';
import OutsourceMfHub from './outsourceMf/OutsourceMfHub';

function OutsourceRequestPage({ user }) {
    const [mfOn, setMfOn] = useState(null);
    useEffect(() => {
        let on = true;
        getFeatures().then((f) => { if (on) setMfOn(isOutsourceMfOn(f, user, user?.email)); }).catch((e) => { console.error('[외주 의뢰서] 설정 읽기 실패 — 스위치 OFF 로 표시:', e?.code || e?.message); if (on) setMfOn(false); });
        return () => { on = false; };
    }, [user]);
    if (mfOn === null) return null;
    if (!mfOn) return <div style={{ padding: 40, textAlign: 'center', color: '#64748b' }}>{'외주 의뢰서는 준비 중입니다.'}</div>;
    return <OutsourceMfHub user={user} />;
}

export default OutsourceRequestPage;
